import Router from '@components/router/router'
import { hasNoSubscription, isTrialActive } from '@components/utils/helper'
import React, { useEffect, useState } from 'react'
import { Slide, ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { SubscriptionBannerContext } from './contexts/subscription-banner.context'
import { QueryClientProvider, QueryClient } from '@tanstack/react-query'
import ScrollToTop from '@common/scroll/scroll-to-top'
import { LoadingProvider } from './contexts/loading.context'
import { HelmetProvider } from 'react-helmet-async'

import { useUser } from '@contexts/user.context'
const queryClient = new QueryClient()

const App: React.FC = () => {
  const { user } = useUser()
  const [bannerDisplay, setBannerDisplay] = useState<boolean>(isTrialActive(user) || hasNoSubscription(user))

  useEffect(() => {
    setBannerDisplay(isTrialActive(user) || hasNoSubscription(user))
  }, [user])

  return (
    <>
      <QueryClientProvider client={queryClient}>
        <ScrollToTop />
        <LoadingProvider>
          <HelmetProvider>
            <SubscriptionBannerContext.Provider value={{ bannerDisplay, setBannerDisplay }}>
              <Router />
              <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={true}
                newestOnTop={true}
                closeOnClick={true}
                rtl={false}
                pauseOnFocusLoss={true}
                draggable={true}
                pauseOnHover={true}
                transition={Slide}
                theme="colored"
              />
            </SubscriptionBannerContext.Provider>
          </HelmetProvider>
        </LoadingProvider>
      </QueryClientProvider>
    </>
  )
}

export default App
